/* Link out to the Site Audit job card for a lead.

   The card itself lives in the CRM (materialdepot-crm), which already renders
   the audited rooms, the site photos, the client signature and the PDF, and
   already holds the Site Audit Supabase credentials. Procurement links to it
   rather than reimplementing that stack in antd — one job-card surface, one
   PDF, one place to fix.

   Orders are raised against the lead: audit_orders.pi / install_orders.pi hold
   the estimate's lead_id, which is the ENQ shown on the PI here. */

export function jobCardUrl(leadId?: string | null): string | null {
  const base = (process.env.REACT_APP_CRM_URL || "").replace(/\/+$/, "");
  const lead = String(leadId || "").trim();
  /* Without a configured CRM host the link would 404 on our own origin, so
     callers hide the action instead of offering a broken one. */
  if (!base || !lead) return null;
  return base + "/job-card?pi=" + encodeURIComponent(lead);
}
